export default "__VITE_ASSET__ae66a59b__"